//-------------------------------------------------------------------------------------------------- Imports
import { Row } from "antd";
import { ConfigurableService, ResponsePackageActivation } from "../../../types/common";
import { StyleSheet } from "../../../StyleSheet";
import CodeServicesComponent from "./CodeServicesComponent";
import ActivateServicesComponent from "./ActivateServicesComponent";
import _ from "lodash";

//-------------------------------------------------------------------------------------------------- Interfaces
interface ActivationProps {
    activation: ResponsePackageActivation;
    dataConf: {
        dataList: ConfigurableService[];
    };
};

//-------------------------------------------------------------------------------------------------- Component
const Activation = (props: ActivationProps) => {
    const { activation , dataConf} = props;
    return (
        <Row style={styles.mainContainer}>
            {
                activation && activation.mdContent && activation.buttonTitle && !_.isEmpty(activation.mdContent) && !_.isEmpty(activation.buttonTitle) ?
                    <>
                        {
                            activation.mdContentConfirm && activation.buttonTitleConfirm && !_.isEmpty(activation.mdContentConfirm) && !_.isEmpty(activation.buttonTitleConfirm) ?
                                <CodeServicesComponent activation={activation} />
                                :
                                <ActivateServicesComponent activation={activation} dataConf={dataConf} />
                        }
                    </>
                    :
                    null
            }
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Services
const styles = StyleSheet.create({
    mainContainer: {
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 20px 10px 20px",
        margin: 0,
    },
});

//-------------------------------------------------------------------------------------------------- Packages
export default Activation;
